import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';

export const DEFAULT_DISPLAY_SIZE = 20;

export const TOPIC_DISPLAY_SIZES = [10, DEFAULT_DISPLAY_SIZE, 50, 100, 250];

const getTopicDisplayOptions = (topicsLength: number) => {
  const options = TOPIC_DISPLAY_SIZES.filter((length) => length <= topicsLength).map((size) => ({
    label: `Top ${size} topics`,
    value: size,
  }));

  if (!TOPIC_DISPLAY_SIZES.includes(topicsLength)) {
    options.push({ label: `Top ${topicsLength} topics`, value: topicsLength });
  }
  return options;
};

interface Props {
  topicsLength: number;
  displaySize: number;
  handleUpdate: (value: number) => void;
}

export const DisplaySizeSelect = ({ topicsLength, displaySize, handleUpdate }: Props) => {
  const options = getTopicDisplayOptions(topicsLength);

  return (
    <div className='d-flex justify-content-end align-items-center gap-2 mb-4'>
      <div style={{ minWidth: 'fit-content' }}>Display:</div>
      <SelectFactory
        selectType={SelectTypes.SingleSelect}
        options={options}
        onChange={(option) => (option ? handleUpdate(option.value) : null)}
        value={options.find((op) => op.value === displaySize) ?? null}
      />
    </div>
  );
};
